import { CSSProperties, FC, SVGProps } from 'react'
import { MaxIcon as MaxIconBase } from '@/utils/icons'

/** fill у svg-иконок = disabled soft → для градиентного Max серим фильтром. */
const isDisabledFill = (fill: CSSProperties['fill']): boolean => {
  if (typeof fill !== 'string' || !fill.trim()) {
    return false
  }
  const normalized = fill.trim().toLowerCase()
  return (
    normalized.includes('disabled') ||
    normalized === 'var(--color-button-icon-disabled-soft)'
  )
}

/**
 * Логотип MAX для CRM-кнопок чата.
 * Базовый MaxIcon с градиентами не реагирует на style.fill — как у Wazzup png.
 */
const MaxChatIcon: FC<SVGProps<SVGSVGElement>> = ({ className, style, ...rest }) => {
  const disabled = isDisabledFill(style?.fill)
  const svgStyle: CSSProperties = {
    ...style,
    fill: undefined,
    ...(disabled
      ? {
          opacity: 0.45,
          filter: 'grayscale(1)',
        }
      : {}),
  }

  return <MaxIconBase className={className} style={svgStyle} {...rest} />
}

export default MaxChatIcon
